// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthenticatorAppForm_container__3eWD8","qrCode":"AuthenticatorAppForm_qrCode__1pxti","formItem":"AuthenticatorAppForm_formItem__R7xfY"};